import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { EnumQRCodeType } from '@models/Common';
import { EnumGenericRoleActionAlerts } from '@pages/BasePage';
import { StringUtils } from '@utils/StringUtils';

import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';


@Component({
    selector: 'app-consumer-identification',
    templateUrl: './consumer-identification.component.html',
    styleUrls: ['./consumer-identification.component.scss'],
})
export class ConsumerIdentificationModalComponent implements OnInit {

    @ViewChild('Card', { static: false }) CardEl: ElementRef;
    @ViewChild('Instructions', { static: false }) InstructionsEl: ElementRef;

    public Data: any;

    public Code: string = "";

    public CardNumber: string = "";

    public CardFrontImage: string | null = null;

    public readonly CARD_WIDTH_MM = 85.6;
    public readonly CARD_HEIGHT_MM = 53.98;
    public readonly CARD_BLEED_MM = 4;
    public readonly CARD_WRAPPER_WIDTH_MM = this.CARD_WIDTH_MM + this.CARD_BLEED_MM * 2;
    public readonly CARD_WRAPPER_HEIGHT_MM = this.CARD_HEIGHT_MM + this.CARD_BLEED_MM * 2;

    private showLoading: Function;
    private dismissLoading: Function;

    constructor(
        private NavParams: NavParams,
        private ModalController: ModalController
    ) {

        this.Data = this.NavParams?.get('data') || [];

        const cardFrontImage: string | null = this.NavParams?.get('cardFrontImage') || null;

        // path vindo do config.json é relativo (ex: "assets/..."); sem "/" inicial resolve contra a rota Angular atual, não a raiz do site
        this.CardFrontImage = cardFrontImage && !/^(https?:)?\//.test(cardFrontImage)
            ? `/${cardFrontImage}`
            : cardFrontImage;

        this.showLoading = this.NavParams?.get('showLoading') || null;
        this.dismissLoading = this.NavParams?.get('dismissLoading') || null;

        const code: string = StringUtils.RemoveWhiteSpace(this.Data?.WalletCard?.Number || null);

        this.Code = code
            ? StringUtils.EncodeQRString(JSON.stringify({ t: EnumQRCodeType.Card, v: code, d: new Date().toISOString() }))
            : '';

        this.CardNumber = code ? StringUtils.FormatToCreditCardNumber(code) : '';
    }

    ngOnInit() { }



    Close() {
        // using the injected ModalController this page
        // can "dismiss" itself and optionally pass back data
        this.ModalController.dismiss(null, EnumGenericRoleActionAlerts.Close);
    }


    async GeneratePdf(ev?: any) {

        ev?.preventDefault();
        ev?.stopPropagation();

        const cardElement = this.CardEl?.nativeElement;
        const instructionsElement = this.InstructionsEl?.nativeElement;

        if (!cardElement || !instructionsElement) return;

        if (this.showLoading)
            await this.showLoading();

        // Captura o cartão isolado, em alta resolução, para manter o QR nítido a este tamanho físico pequeno
        const cardCanvas = await html2canvas(cardElement, { scale: 3 });
        const cardImgData = cardCanvas.toDataURL('image/png');

        // Captura o bloco de instruções à parte (não precisa de escala física real)
        const instructionsCanvas = await html2canvas(instructionsElement, { scale: 2 });
        const instructionsImgData = instructionsCanvas.toDataURL('image/png');
        const instructionsAspectRatio = instructionsCanvas.width / instructionsCanvas.height;

        // Define PDF A4
        const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        const margin = 20;
        const usableWidth = pageWidth - margin * 2;

        // Cartão ao tamanho físico real (mesmas dimensões mm do CSS), centrado no topo
        const cardWidthMM = this.CARD_WRAPPER_WIDTH_MM;
        const cardHeightMM = this.CARD_WRAPPER_HEIGHT_MM;
        const cardX = (pageWidth - cardWidthMM) / 2;
        const cardY = margin;

        pdf.addImage(cardImgData, 'PNG', cardX, cardY, cardWidthMM, cardHeightMM);

        // Aviso de escala, por baixo do cartão
        const noteY = cardY + cardHeightMM + 5;
        pdf.saveGraphicsState();
        pdf.setFontSize(8);
        pdf.text('Imprimir a Tamanho Real (100%) — sem ajustar à página.', pageWidth / 2, noteY, { align: 'center' });
        pdf.restoreGraphicsState();

        // Instruções, com aspect-fit no espaço restante da página
        const instructionsY = noteY + 6;
        const usableHeight = pageHeight - margin - instructionsY;
        const pageAspectRatio = usableWidth / usableHeight;

        let renderWidth: number, renderHeight: number;

        if (instructionsAspectRatio > pageAspectRatio) {
            renderWidth = usableWidth;
            renderHeight = renderWidth / instructionsAspectRatio;
        } else {
            renderHeight = usableHeight;
            renderWidth = renderHeight * instructionsAspectRatio;
        }

        const instructionsX = (pageWidth - renderWidth) / 2;

        pdf.addImage(instructionsImgData, 'PNG', instructionsX, instructionsY, renderWidth, renderHeight);

        const today = new Date().getTime();
        const textfooter = `${today}/${this.Code}`;

        pdf.saveGraphicsState();
        pdf.setFontSize(6);
        pdf.text(textfooter, 10, pageHeight - 10);
        pdf.restoreGraphicsState();

        if (this.dismissLoading)
            await this.dismissLoading();

        pdf.save(`identidade_cartao_${new Date().getTime()}.pdf`);
    }
}
